import type { UserRole } from '@mm/shared';

// Фиксированные цвета — на любой доске одинаково считывается «учитель/ученик».
const STAFF_RED = '#e11d48'; // tailwind rose-600
const STUDENT_BLUE = '#2563eb'; // tailwind blue-600
const FALLBACK = '#888';

export const ROLE_COLORS: Record<UserRole, string> = {
  TUTOR: STAFF_RED,
  ADMIN: STAFF_RED,
  STUDENT: STUDENT_BLUE,
};

export function colorForRole(role: UserRole): string {
  return ROLE_COLORS[role] ?? FALLBACK;
}
